import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 18,
	viewBox: "0 0 17 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.58524 2.63743C7.95723 2.32744 9.39267 2.46926 10.6775 3.04174C11.0558 3.21032 11.4992 3.04027 11.6678 2.66192C11.8364 2.28356 11.6663 1.84018 11.288 1.6716C9.70771 0.967472 7.94217 0.793036 6.25467 1.17431C4.56717 1.55557 3.04812 2.47212 1.92407 3.78725C0.800032 5.10238 0.131222 6.74562 0.0173907 8.47191C-0.0964402 10.1982 0.350807 11.915 1.29243 13.3664C2.23405 14.8177 3.6196 15.9258 5.24243 16.5253C6.86525 17.1249 8.63841 17.1838 10.2975 16.6933C11.9565 16.2027 13.4125 15.1891 14.4484 13.8034C15.4843 12.4178 16.0445 10.7344 16.0455 9.00437V9.00394V8.33485C16.0455 7.92064 15.7097 7.58485 15.2955 7.58485C14.8812 7.58485 14.5455 7.92064 14.5455 8.33485V9.00351C14.5447 10.4101 14.0892 11.7787 13.247 12.9053C12.4048 14.0319 11.221 14.856 9.87215 15.2548C8.5233 15.6536 7.08167 15.6057 5.76226 15.1183C4.44285 14.6308 3.31635 13.7299 2.55079 12.55C1.78522 11.37 1.42159 9.97413 1.51414 8.57061C1.60669 7.16708 2.15045 5.83107 3.06433 4.76183C3.97821 3.69259 5.21325 2.94741 6.58524 2.63743ZM15.826 3.71166C16.1188 3.41862 16.1186 2.94375 15.8255 2.651C15.5325 2.35825 15.0576 2.35849 14.7649 2.65153L8.02246 9.40067L6.37124 7.74945C6.07835 7.45655 5.60347 7.45655 5.31058 7.74945C5.01769 8.04234 5.01769 8.51721 5.31058 8.81011L7.4924 10.9919C7.63309 11.1326 7.82394 11.2116 8.02291 11.2116C8.22189 11.2115 8.41269 11.1324 8.55332 10.9917L15.826 3.71166Z",
		fill: "#70a84c"
	})]
});
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
